import getters from './getters';
import mutations from './mutations';

const namespaced = true;

const state = {};

export default {
  namespaced,
  getters,
  mutations,
  state,
};
